<template>
  <div>
    <!-- 底部 -->
    <div class="footer_wrap">
      <div class="footer_box type_area">
        <div class="left_info">
          <div class="top_layout">
            <span
              v-for="item in navList"
              :key="item.Id"
              @click="handlePage(item)"
            >
              {{ item.Title }}
            </span>
            <span> </span>
          </div>
          <div class="layout_box">
            <div class="layout">
              地址：{{ footerInfo.MapProvince ? footerInfo.MapProvince : ''
              }}{{ footerInfo.MapCity ? footerInfo.MapCity : ''
              }}{{ footerInfo.MapDistrict ? footerInfo.MapDistrict : ''
              }}{{ footerInfo.MapTownship ? footerInfo.MapTownship : ''
              }}{{ footerInfo.MapStreet ? footerInfo.MapStreet : ''
              }}{{ footerInfo.MapAddress ? footerInfo.MapAddress : '' }}
              <span>电话：{{ footerInfo.CompanyPhone }}</span>
            </div>
            <div class="layout layout2">
              版权所有 ©金多银多珠宝广场 豫ICP备16036500号
              <span>技术支持：铁哥们网络</span>
            </div>
          </div>
        </div>
        <div class="right_code">
          <span>
            <i class="iconfont iconweixin"></i>
            关注我们
          </span>
          <img :src="footerInfo.Eweim" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [],
      footerInfo: {}
    }
  },

  created() {
    this.getNavList()
    this.getFooterInfo()
  },

  methods: {
    // 导航列表
    async getNavList() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetDhangListV2'
      )
      res.data.push({
        Id: 99999,
        Title: '营业执照'
      })
      this.navList = res.data
    },

    // 底部信息
    async getFooterInfo() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetSX_CompanyList'
      )
      this.footerInfo = res.data
    },

    handlePage(item) {
      if (item.Title === '首页') {
        this.$router.push({
          path: '/',
          query: {
            id: 0
          }
        })
      }

      if (item.Title === '关于我们') {
        this.$router.push({
          path: '/about-as',
          query: {
            id: item.Id
          }
        })
      }

      if (item.Title === '入驻品牌') {
        this.$router.push({
          path: '/settled-brand',
          query: {
            id: item.Id
          }
        })
      }

      if (item.Title === '品牌招商') {
        this.$router.push({
          path: '/brand-merchants',
          query: {
            id: item.Id
          }
        })
      }

      if (item.Title === '广场动态') {
        this.$router.push({
          path: '/square-dynamic',
          query: {
            id: item.Id
          }
        })
      }

      if (item.Title === '联系我们') {
        this.$router.push({
          path: '/contact-us',
          query: {
            id: item.Id
          }
        })
      }

      if (item.Title === '营业执照') {
        const routeURL = this.$router.resolve({ path: '/business-license' })
        window.open(routeURL.href, '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 底部
.footer_wrap {
  font-size: 16px;
  background-color: #b92e32;

  .footer_box {
    display: flex;
    justify-content: space-between;

    .left_info {
      padding-top: 50px;

      .top_layout {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        span {
          color: #feeb09;
          border-left: 2px solid #feeb09;
          padding: 0 35px;
          cursor: pointer;
        }
        span:nth-child(1) {
          border: none;
          padding: 0;
          padding-right: 35px;
        }
      }

      .layout {
        color: #fff;
        padding: 50px 0 25px;
        p {
          margin: 0;
        }
        span {
          padding-left: 55px;
        }
      }

      .layout2 {
        padding: 0 0 25px;
      }
    }

    .right_code {
      display: flex;
      font-size: 16px;
      padding-top: 50px;

      span {
        padding-top: 20px;
        color: #fff;
        writing-mode: vertical-rl;
        i {
          font-size: 20px;
        }
        padding-right: 8px;
      }

      img {
        width: 125px;
        height: 125px;
      }
    }
  }
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

// bootstrap
.card {
  background-color: transparent;
}

@media screen and (max-width: 480px) {
  .type_area {
    width: 375px;
  }

  // 底部
  .footer_wrap {
    font-size: 16px;
    // width: 100%;
    height: 100%;
    background-color: #b92e32;

    .footer_box {
      display: block;
      padding: 50px 30px;

      .left_info {
        padding-top: 0;

        .top_layout {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 36rpx !important;
          line-height: 25px;
          border-bottom: 1px solid #ae1217;
          span {
            width: 75px;
            text-align: center;
            display: inline-block;
            border: none;
            padding: 0;
            padding-bottom: 15px;
          }
          span:nth-child(1) {
            padding: 0;
            padding-bottom: 15px;
          }
        }

        .layout_box {
          padding: 20px 0;
        }

        .layout {
          padding: 0;
          line-height: 30px;
          span {
            display: block;
            padding: 0;
          }
        }

        .layout2 {
          padding-bottom: 0;
        }
      }

      .right_code {
        display: block;
        font-size: 16px;
        padding: 0;

        span {
          padding: 0 0 10px;
          text-align: center;
          display: block;
          color: #fff;
          writing-mode: horizontal-tb;
          i {
            font-size: 20px;
          }
        }

        img {
          display: block;
          margin: auto;
          width: 125px;
          height: 125px;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
